
import { Component, Prop, Vue, Ref, Watch } from "vue-property-decorator"

// @ts-ignore
import speakeasy from "speakeasy"

import api from "@/services/api"
import { AuthSetup } from "@/types/user"

@Component({
	components: {}
})
export default class MFAEntry extends Vue {
	@Ref()
	authCodeTextBox!: HTMLInputElement

	@Prop({ default: false })
	isSystem!: boolean

	private localAuthCode: string | null = null
	private submitting: boolean = false
	private error: any = null

	mounted () {
		setTimeout(() => {
			this.authCodeTextBox.focus()
		}, 100)
	}

	async enterCode () {
		if (!this.localAuthCode) return

		this.submitting = true
		this.error = null

		try {
			if (this.isSystem) {
				await api.submitSystemMfa({
					authCode: this.localAuthCode
				})
			} else {
				await api.submitMfa({
					authCode: this.localAuthCode
				})
			}

			this.$emit("success")
		} catch (err) {
			this.error = err
		}
		this.submitting = false
	}
}

